"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _svg;

var _excluded = ["type", "forwardedRef"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var context = process.env.NODE_ENV === 'test' ? {
  keys: function keys() {
    return [];
  }
} : require.context('./', false, /\.js$/);
var icons = context.keys().filter(function (iconKey) {
  return iconKey !== './Icon.js' && iconKey !== './index.js';
}).reduce(function (acc, iconKey) {
  var icon = iconKey.slice('./Icon'.length, -'.js'.length).replace(/(\B[A-Z])/g, '-$1').toLowerCase();
  acc[icon] = context(iconKey)["default"];
  return acc;
}, {});
exports.icons = icons;

var Icon = function Icon(_ref) {
  var type = _ref.type,
      forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, _excluded);

  if (process.NODE_ENV === 'development') {
    if (!type || icons[type]) {
      throw new Error('Unknow icon type -> ', type);
    }
  }

  return /*#__PURE__*/_react["default"].cloneElement(icons[type], _extends({
    ref: forwardedRef
  }, props));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = {
  type: _propTypes["default"].oneOf(Object.keys(icons)).isRequired
} : void 0;

var _default = process.env.NODE_ENV === 'test' ? function () {
  return _svg || (_svg = /*#__PURE__*/_react["default"].createElement("svg", null));
} : Icon;

exports["default"] = _default;